import { useState } from "react";
import { useSelector } from "react-redux";
import { isLoadingSelector } from "store1/expense data/expenseData.slice.selector";
import ExpensesManagmentData from "./ExpensesList/expensesList";

const ExpensesManagmentDataWrapper = () => {
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const isLoadingExpenses = useSelector(isLoadingSelector);
    return (
        <ExpensesManagmentData
            isLoadingExpenses={isLoadingExpenses}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            pageSize={pageSize}
            setPageSize={setPageSize}
        />
    );
};

export default ExpensesManagmentDataWrapper;
